import React from 'react';
import { Typography } from '@rentspree/component-2023.components.atoms.typography';

export interface Tab {
  key: string;
  label: string;
}

export interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabClick: (tabKey: string) => void;
  className?: string;
  style?: React.CSSProperties;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabClick,
  className,
  style,
}) => {
  return (
    <div
      className={className}
      style={{
        background: '#ffffff',
        borderBottom: '1px solid #f3f4f6',
        padding: '0 80px',
        ...style,
      }}
      data-testid='tab-navigation'
    >
      <div
        style={{
          width: 1280,
          margin: '0 auto',
          paddingLeft: 48,
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: 32,
            height: 54,
            alignItems: 'center',
          }}
        >
          {tabs.map(tab => (
            <button
              key={tab.key}
              onClick={() => onTabClick(tab.key)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '15px 0',
                position: 'relative',
                height: '100%',
              }}
              data-testid={`tab-${tab.key}`}
            >
              <Typography
                variant='body1'
                style={{
                  color: activeTab === tab.key ? '#000000' : '#6b7280',
                  fontWeight: activeTab === tab.key ? 600 : 500,
                  fontSize: '14px',
                }}
              >
                {tab.label}
              </Typography>
              {activeTab === tab.key && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 2,
                    background: '#000000',
                  }}
                  data-testid='active-tab-indicator'
                />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
